import borders from "./borders";
import colors from "./colors";
import radii from "./radius";
import shadows from "./shadows";
import spacing from "./spacing";
import typography from "./typography";
import blur from "./blur";
import breakpoints from "./breakpoints";
const foundations = {
  radii,
  blur,
  colors,
  breakpoints,
  ...typography,
  shadows,
  space: spacing,
  borders,
};

export default foundations;
